/* WINROVA Atelier 1.0 — progressive enhancement; store/cart remain usable without JS */
(() => {
  'use strict';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const toILS = (cents) => {
    try { return new Intl.NumberFormat('he-IL', {style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 2}).format(Number(cents || 0) / 100); }
    catch { return '₪' + (Number(cents || 0)/100).toFixed(2); }
  };
  const msg = (text, error = false) => {
    const toast = $('[data-cart-toast]'); if (!toast) return;
    toast.textContent = text; toast.hidden = false;
    toast.style.background = error ? '#a33b37' : '';
    window.clearTimeout(toast._hide);
    toast._hide = window.setTimeout(() => { toast.hidden = true; }, 3500);
  };
  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: {'Accept': 'application/json'} });
      if (!response.ok) return;
      const cart = await response.json();
      $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; node.hidden = cart.item_count < 1; });
    } catch (err) { console.warn('WINROVA cart refresh:', err); }
  };
  const postToCart = async (form) => {
    const response = await fetch('/cart/add.js', { method:'POST', body: new FormData(form), headers: {'Accept':'application/json'} });
    let data = null;
    try { data = await response.json(); } catch { /* fallback below */ }
    if (!response.ok) throw new Error(data?.description || data?.message || 'לא הצלחנו להוסיף לסל');
    await updateCartCount();
    msg('הפריט נוסף לסל ✓');
  };
  // Header / navigation
  const mobile = $('[data-mobile-menu]');
  const toggleMenu = (open) => {
    if (!mobile) return;
    mobile.hidden = !open;
    $('[data-menu-open]')?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('is-locked', open);
    if (open) $('[data-menu-close]', mobile)?.focus();
  };
  $('[data-menu-open]')?.addEventListener('click', () => toggleMenu(true));
  $$('[data-menu-close]').forEach(x => x.addEventListener('click', () => toggleMenu(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') toggleMenu(false); });
  // quick add only for single default variants
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-quick-add], [data-product-form]');
    if (!form) return;
    event.preventDefault();
    const btn = $('button[type="submit"]', form); if (btn?.disabled) return;
    if (btn) btn.disabled = true;
    try { await postToCart(form); }
    catch (err) { msg(err.message || 'אירעה שגיאה. נסו שוב.', true); }
    finally { if (btn) btn.disabled = false; }
  });
  // Product page: variant availability, images and quantity offers
  $$('[data-product-root]').forEach(root => {
    let variants = [];
    try { variants = JSON.parse($('[data-product-variants]', root)?.textContent || '[]'); }
    catch { variants = []; }
    const fields = $$('[data-option-index]', root);
    const idField = $('[data-variant-id]', root);
    const submit = $('[data-add-to-cart]', root);
    const addLabel = $('[data-add-label]', root);
    const variantError = $('[data-variant-error]', root);
    const current = variants.find(v => String(v.id) === idField?.value) || variants[0];
    const selectedOptions = current?.options ? [...current.options] : fields.map(field => $('[data-option-button].is-selected', field)?.dataset.optionValue);
    const unavailable = () => {
      if (submit) submit.disabled = true;
      if (addLabel) addLabel.textContent = 'האפשרות אינה זמינה';
      if (variantError) variantError.hidden = false;
    };
    const applyVariant = (variant, updateUrl = true) => {
      if (!variant) { unavailable(); return; }
      if (idField) idField.value = variant.id;
      const price = $('[data-variant-price]', root), compare = $('[data-variant-compare]', root);
      if (price) price.textContent = toILS(variant.price);
      if (compare) {
        compare.hidden = !(Number(variant.compare_at_price) > Number(variant.price));
        compare.textContent = !compare.hidden ? toILS(variant.compare_at_price) : '';
      }
      if (submit) submit.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'הוספה לסל' : 'אזל מהמלאי';
      if (variantError) variantError.hidden = true;
      if (variant.featured_image?.src) {
        const mainImg = $('#product-main-image', root);
        if (mainImg) { mainImg.src = variant.featured_image.src; mainImg.removeAttribute('srcset'); }
      }
      if (updateUrl && history.replaceState) {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    fields.forEach((field, index) => {
      $$('[data-option-button]', field).forEach(button => button.addEventListener('click', () => {
        const choice = button.dataset.optionValue;
        selectedOptions[index] = choice;
        $$('[data-option-button]', field).forEach(b => { const active = b === button; b.classList.toggle('is-selected', active); b.setAttribute('aria-pressed', String(active)); });
        const choiceLabel = $('[data-choice-label]', field); if (choiceLabel) choiceLabel.textContent = button.textContent.trim();
        const match = variants.find(v => v.options.length === selectedOptions.length && v.options.every((o, i) => o === selectedOptions[i]));
        applyVariant(match);
      }));
    });
    if (current) applyVariant(current, false);
    const quantity = $('input[name="quantity"]', root);
    $('[data-quantity-minus]', root)?.addEventListener('click', () => { if (quantity) quantity.value = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1); });
    $('[data-quantity-plus]', root)?.addEventListener('click', () => { if (quantity) quantity.value = Math.min(99, (parseInt(quantity.value, 10) || 1) + 1); });
    $$('[data-bundle-qty]', root).forEach(btn => btn.addEventListener('click', () => {
      if (quantity) quantity.value = btn.dataset.bundleQty;
      $$('[data-bundle-qty]', root).forEach(other => other.classList.toggle('is-selected', other === btn));
    }));
    // gallery thumbnails & zoom
    const main = $('#product-main-image', root);
    $$('[data-gallery-thumb]', root).forEach(btn => btn.addEventListener('click', () => {
      if (!main) return;
      main.src = btn.dataset.full; main.removeAttribute('srcset'); main.alt = btn.dataset.alt || '';
      $$('[data-gallery-thumb]', root).forEach(other => { other.classList.toggle('is-active', other === btn); other.setAttribute('aria-pressed', String(other === btn)); });
    }));
    const modal = $('[data-gallery-modal]', root);
    $('[data-gallery-zoom]', root)?.addEventListener('click', () => {
      if (!modal || !main || !modal.showModal) return;
      const img = $('img', modal); img.src = main.currentSrc || main.src; img.alt = main.alt; modal.showModal();
    });
    $('[data-gallery-modal-close]', root)?.addEventListener('click', () => modal?.close());
    modal?.addEventListener('click', e => { if (e.target === modal) modal.close(); });
    const guide = $('[data-size-guide-dialog]', root);
    $('[data-size-guide-open]', root)?.addEventListener('click', () => guide?.showModal?.());
    $('[data-size-guide-close]', root)?.addEventListener('click', () => guide?.close());
  });
  // native collection filters & sorting
  $$('[data-sort-select]').forEach(select => select.addEventListener('change', () => select.form?.submit()));
  $$('[data-collection-page]').forEach(root => {
    const panel = $('[data-filter-panel]', root);
    $('[data-filter-open]', root)?.addEventListener('click', () => { panel?.classList.add('is-open'); document.body.classList.add('is-locked'); });
    $('[data-filter-close]', root)?.addEventListener('click', () => { panel?.classList.remove('is-open'); document.body.classList.remove('is-locked'); });
  });
  // Shopify recommended items: lazy-load official section HTML
  $$('[data-recommendations-target]').forEach(async target => {
    const url = target.dataset.recommendationsUrl;
    if (!url) return;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const markup = await response.text();
      const temp = document.createElement('div'); temp.innerHTML = markup;
      const section = $('.recommendations', temp);
      if (section) target.replaceWith(section);
    } catch (err) { console.warn('WINROVA related products:', err); }
  });
})();
